import { render, staticRenderFns } from "./addProcedure.vue?vue&type=template&id=28286644&"
import script from "./addProcedure.vue?vue&type=script&lang=js&"
export * from "./addProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports